module.exports = __webpack_public_path__ + "static/img/start-prediction-title.d486679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/start-prediction-title.png
// module id = Oc7b
// module chunks = 1